interface LogoProps {
  className?: string;
  size?: number;
}

export function Logo({ className = "", size = 32 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shadow/depth layer */}
      <rect
        x="9.5"
        y="4.5"
        width="22"
        height="32"
        rx="1.5"
        fill="currentColor"
        fillOpacity="0.04"
      />
      
      {/* Paper background */}
      <rect
        x="8"
        y="3"
        width="24"
        height="34"
        rx="1.5"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Top fold corner */}
      <path
        d="M 26 3 L 32 3 L 32 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.3"
      />
      
      {/* Text lines - top section */}
      <line
        x1="12"
        y1="10"
        x2="28"
        y2="10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.25"
      />
      <line
        x1="12"
        y1="14"
        x2="26"
        y2="14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.25"
      />
      
      {/* Highlighted section background */}
      <rect
        x="11"
        y="17.5"
        width="18"
        height="4"
        rx="1"
        fill="#FFC107"
        opacity="0.35"
      />
      
      {/* Highlighted text line */}
      <line
        x1="12"
        y1="19.5"
        x2="28"
        y2="19.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.9"
      />
      
      {/* Text lines - bottom section */}
      <line
        x1="12"
        y1="25"
        x2="24"
        y2="25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.25"
      />
      <line
        x1="12"
        y1="29"
        x2="28"
        y2="29"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.25"
      />
      <line
        x1="12"
        y1="33"
        x2="22"
        y2="33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.15"
      />
    </svg>
  );
}
